<template>
  <div class="status-counter">
    <div class="status-counter__grid">
      <!-- Processing Group -->
      <div class="status-counter__item" :class="{ 'status-counter__item--selected': selectedStatus === 'Processing' }" :style="getStatusStyle('Processing')" @click="selectStatus('Processing')">
        <div class="status-counter__header">
          <i class="fa fa-cog status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.processing') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.processing }}</span>
        <div v-if="!isWallfileZonePage" class="status-counter__subgroup">
          <span class="status-counter__sub" :class="{ 'status-counter__sub--highlight': newCount.processingReady > 0 }">
            <i class="fa fa-check-circle"></i> {{ newCount.processingReady }}
          </span>
          <span class="status-counter__sub" :class="{ 'status-counter__sub--warning': newCount.processingNot > 0 }">
            <i class="fa fa-clock-o"></i> {{ newCount.processingNot }}
          </span>
          <span class="status-counter__sub" :class="{ 'status-counter__sub--alert': newCount.processingMissing > 0 }">
            <i class="fa fa-question-circle"></i> {{ newCount.processingMissing }}
          </span>
        </div>
      </div>

      <!-- Dispatch -->
      <div class="status-counter__item" :class="{ 'status-counter__item--selected': selectedStatus === 'Dispatch' }" :style="getStatusStyle('Dispatch')" @click="selectStatus('Dispatch')">
        <div class="status-counter__header">
          <i class="fa fa-paper-plane status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.dispatch') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.dispatch }}</span>
      </div>

      <!-- Pick -->
      <div v-if="!isWallfileZonePage" class="status-counter__item" :class="{ 'status-counter__item--selected': selectedStatus === 'Pick' }" :style="getStatusStyle('Pick')" @click="selectStatus('Pick')">
        <div class="status-counter__header">
          <i class="fa fa-box status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.pick') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.pick }}</span>
      </div>

      <!-- Transit -->
      <div v-if="!isWallfileZonePage" class="status-counter__item" :class="{ 'status-counter__item--selected': selectedStatus === 'Transit' }" :style="getStatusStyle('Transit')" @click="selectStatus('Transit')">
        <div class="status-counter__header">
          <i class="fa fa-truck status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.transit') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.transit }}</span>
      </div>

      <!-- Waiting -->
      <div class="status-counter__item" :class="{ 'status-counter__item--selected': selectedStatus === 'Attente' }" :style="getStatusStyle('Attente')" @click="selectStatus('Attente')">
        <div class="status-counter__header">
          <i class="fa fa-clock-o status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.waiting') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.waiting }}</span>
      </div>

      <!-- Delivered -->
      <div class="status-counter__item" :class="{ 'status-counter__item--selected': selectedStatus === 'Drop' }" :style="getStatusStyle('Drop')" @click="selectStatus('Drop')">
        <div class="status-counter__header">
          <i class="fa fa-check-circle status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.delivered') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.drop }}</span>
      </div>

      <!-- Transferred -->
      <div class="status-counter__item" :class="{ 'status-counter__item--selected': selectedStatus === 'Transférée' }" :style="getStatusStyle('Transférée')" @click="selectStatus('Transférée')">
        <div class="status-counter__header">
          <i class="fa fa-exchange status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.transferred') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.transfer }}</span>
      </div>

      <!-- Rejected -->
      <div class="status-counter__item" :class="{ 'status-counter__item--selected': selectedStatus === 'Reject' }" :style="getStatusStyle('Reject')" @click="selectStatus('Reject')">
        <div class="status-counter__header">
          <i class="fa fa-times-circle status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.rejected') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.reject }}</span>
      </div>

      <!-- Inspection -->
      <div class="status-counter__item" :class="{ 'status-counter__item--selected': selectedStatus === 'Inspection' }" :style="getStatusStyle('Inspection')" @click="selectStatus('Inspection')">
        <div class="status-counter__header">
          <i class="fa fa-search status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.inspection') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.inspection }}</span>
      </div>

      <!-- Warning -->
      <div class="status-counter__item status-counter__item--warning" :class="{ 'status-counter__item--active': newCount.warning > 0, 'status-counter__item--selected': selectedStatus === 'warning' }" @click="selectStatus('warning')">
        <div class="status-counter__header">
          <i class="fa fa-exclamation-triangle status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.warning') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.warning }}</span>
      </div>

      <!-- Late -->
      <div class="status-counter__item status-counter__item--late" :class="{ 'status-counter__item--active': newCount.late > 0, 'status-counter__item--selected': selectedStatus === 'late' }" @click="selectStatus('late')">
        <div class="status-counter__header">
          <i class="fa fa-exclamation-circle status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.late') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.late }}</span>
      </div>

      <!-- To Bill -->
      <div class="status-counter__item status-counter__item--billing" :class="{ 'status-counter__item--selected': selectedStatus === 'isBilling' }" @click="selectStatus('isBilling')">
        <div class="status-counter__header">
          <i class="fa fa-file-invoice-dollar status-counter__icon"></i>
          <span class="status-counter__label">{{ $t('OrderCurrent.stats.toBill') }}</span>
        </div>
        <span class="status-counter__value">{{ newCount.toBill }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ORDER_STATUS, ORDER_STATUS_COLORS, isWarningOrder, isLateOrder } from '../../../../constants/orderStatus'

export default {
  name: 'OrderStatusCounter',

  data () {
    return {
      processingState: {
        processing: ORDER_STATUS.PROCESSING,
        not: 'Not',
        ready: 'Ready',
        missing: 'Missing'
      }
    }
  },

  props: {
    filterResults: {
      type: Array,
      default: () => []
    },
    processedArray: {
      type: Array,
      default: () => []
    },
    isWallfileZonePage: {
      type: Boolean,
      default: false
    },
    selectedStatus: {
      type: String,
      default: ''
    }
  },

  methods: {
    selectStatus (status) {
      this.$emit('filter', status === this.selectedStatus ? '' : status)
    },
    getStatusStyle (status) {
      const config = ORDER_STATUS_COLORS[status]
      if (!config) return {}
      return {
        '--status-color': config.bg
      }
    },

    setOtherProcessing (order) {
      let responseString = ''

      if (order.survey) {
        for (const key in order.survey) {
          if (Object.hasOwnProperty.call(order.survey, key)) {
            order.survey[key].forEach(question => {
              if (question.id === '1') {
                if (question.answer === true) {
                  responseString = this.processingState.ready
                } else if (question.answer === false) {
                  const questionWithTimestamp = order.survey[key].find(q => q.id === '1.1')
                  if (questionWithTimestamp) {
                    let time = this.getTimestamp(questionWithTimestamp.answer)
                    if (time > Date.now()) {
                      responseString = this.processingState.not
                    } else if (time < Date.now()) {
                      responseString = this.processingState.ready
                    }
                  }
                }
                return
              }
            })
          }
        }
      } else {
        responseString = this.processingState.missing
      }

      return responseString
    },

    getTimestamp (receivedDate) {
      return Date.parse(receivedDate)
    },

    countNewNote (processedArray) {
      let count = 0
      processedArray.forEach(o => {
        if (o.read === false) count++
      })
      return count
    },

    countNewDate (processedArray) {
      let count = 0
      processedArray.forEach(o => {
        if (o.datePromis !== null && o.datePromis !== '' && o.datePromis !== undefined) {
          var fdate = new Date(o.datePromis)
          var today = new Date()
          today.setHours(0, 0, 0, 0)
          if (fdate <= today) {
            count++
          }
        }
      })
      return count
    }
  },

  computed: {
    newCount () {
      let count = {
        processing: 0,
        processingReady: 0,
        processingNot: 0,
        processingMissing: 0,
        toBill: 0,
        dispatch: 0,
        pick: 0,
        transit: 0,
        drop: 0,
        transfer: 0,
        reject: 0,
        waiting: 0,
        newNote: 0,
        newDate: 0,
        inspection: 0,
        warning: 0,
        late: 0
      }

      count.newNote = this.countNewNote(this.processedArray)
      count.newDate = this.countNewDate(this.processedArray)

      this.filterResults.forEach(o => {
        if (o.status === ORDER_STATUS.PROCESSING) {
          count.processing++
          switch (this.setOtherProcessing(o)) {
            case this.processingState.ready:
              count.processingReady++
              break
            case this.processingState.not:
              count.processingNot++
              break
            case this.processingState.missing:
              count.processingMissing++
              break
          }
        }
        if (o.status === ORDER_STATUS.DISPATCH) count.dispatch++
        if (o.status === ORDER_STATUS.PICK) count.pick++
        if (o.status === ORDER_STATUS.TRANSIT) count.transit++
        if (o.status === ORDER_STATUS.DROP) count.drop++
        if (o.status === ORDER_STATUS.IS_BILLING) count.toBill++
        if (o.status === ORDER_STATUS.TRANSFEREE) count.transfer++
        if (o.status === ORDER_STATUS.REJECT) count.reject++
        if (o.status === ORDER_STATUS.INSPECTION) count.inspection++
        if (o.status === ORDER_STATUS.ATTENTE) count.waiting++
        if (!isLateOrder(o) && isWarningOrder(o)) count.warning++
        if (isLateOrder(o)) count.late++
      })

      return count
    }
  }
}
</script>

<style scoped>
.status-counter {
  background-color: #2c2d2f;
  border-radius: 8px;
  padding: 1rem;
}

.status-counter__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.75rem;
}

.status-counter__item {
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  border-left: 3px solid var(--status-color, #6b7280);
  transition: all 0.2s;
  cursor: pointer;
}

.status-counter__item:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.status-counter__item--selected {
  background-color: rgba(255, 255, 255, 0.15);
  border-left-width: 5px;
  box-shadow: 0 0 0 1px var(--status-color, #6b7280);
}

.status-counter__item--warning {
  --status-color: #F59E0B;
}

.status-counter__item--late {
  --status-color: #EF4444;
}

.status-counter__item--billing {
  --status-color: #059669;
}

.status-counter__item--active {
  animation: pulse-border 2s infinite;
}

.status-counter__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.status-counter__icon {
  font-size: 0.875rem;
  color: var(--status-color, #9ca3af);
}

.status-counter__label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.status-counter__value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #ffffff;
}

.status-counter__subgroup {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.status-counter__sub {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
}

.status-counter__sub i {
  font-size: 0.625rem;
}

.status-counter__sub--highlight {
  color: #10B981;
}

.status-counter__sub--warning {
  color: #F59E0B;
}

.status-counter__sub--alert {
  color: #EF4444;
}

@keyframes pulse-border {
  0%, 100% {
    border-left-color: var(--status-color);
  }
  50% {
    border-left-color: rgba(255, 255, 255, 0.3);
  }
}

@media (max-width: 768px) {
  .status-counter__grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .status-counter__value {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .status-counter__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  .status-counter__item {
    padding: 0.5rem;
  }
}
</style>
